export default function (valueType) {
  return {
    props: {
      value: valueType
    },
    data () {
      return {
        id: null,
        localValue: null
      }
    },
    mounted () {
      this.id = this._uid.toString()
    },
    created () {
      this.localValue = this.value
      this.$watch('value', value => {
        this.localValue = value
      })
      this.$watch('localValue', value => {
        this.$emit('input', value)
        this.$emit('change', value)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/wrapper.mixin.js